import React from "react";

export default function UpscMainsPattern() {
  return (
    <div className="p-4">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center md:text-left text-blue-700">
        UPSC Mains Exam Pattern & Marking Scheme
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 text-sm md:text-base table-auto">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="border px-3 py-2 text-left">Category</th>
              <th className="border px-3 py-2 text-left">Paper</th>
              <th className="border px-3 py-2 text-left">Subject</th>
              <th className="border px-3 py-2 text-center">Marks</th>
            </tr>
          </thead>
          <tbody>
            {/* Qualifying Papers */}
            <tr className="bg-white">
              <td
                rowSpan="2"
                className="border px-3 py-2 font-medium align-top"
              >
                Qualifying Papers
              </td>
              <td className="border px-3 py-2">Paper A</td>
              <td className="border px-3 py-2">
                Indian Language (from Eighth Schedule of Constitution)
              </td>
              <td className="border px-3 py-2 text-center">300</td>
            </tr>
            <tr className="bg-white">
              <td className="border px-3 py-2">Paper B</td>
              <td className="border px-3 py-2">English</td>
              <td className="border px-3 py-2 text-center">300</td>
            </tr>

            {/* Papers Counted for Merit */}
            <tr className="bg-gray-50">
              <td
                rowSpan="7"
                className="border px-3 py-2 font-medium align-top"
              >
                Papers Counted for Merit
              </td>
              <td className="border px-3 py-2">Paper I</td>
              <td className="border px-3 py-2">Essay</td>
              <td className="border px-3 py-2 text-center">250</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">Paper II</td>
              <td className="border px-3 py-2">
                General Studies-I (Indian Heritage & Culture, History,
                Geography, Society)
              </td>
              <td className="border px-3 py-2 text-center">250</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">Paper III</td>
              <td className="border px-3 py-2">
                General Studies-II (Governance, Constitution, Polity, Social
                Justice, IR)
              </td>
              <td className="border px-3 py-2 text-center">250</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">Paper IV</td>
              <td className="border px-3 py-2">
                General Studies-III (Technology, Economic Development,
                Environment, Security)
              </td>
              <td className="border px-3 py-2 text-center">250</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">Paper V</td>
              <td className="border px-3 py-2">
                General Studies-IV (Ethics, Integrity, Aptitude)
              </td>
              <td className="border px-3 py-2 text-center">250</td>
            </tr>

            {/* Optional Papers with asterisk and option numbers */}
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">
                Paper VI <strong>*</strong>
              </td>
              <td className="border px-3 py-2">
                Optional Subject – Paper 1 (i)
              </td>
              <td className="border px-3 py-2 text-center">
                250 <strong>*</strong>
              </td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border px-3 py-2">
                Paper VII <strong>*</strong>
              </td>
              <td className="border px-3 py-2">
                Optional Subject – Paper 2 (ii)
              </td>
              <td className="border px-3 py-2 text-center">
                250 <strong>*</strong>
              </td>
            </tr>

            {/* Subtotal */}
            <tr className="bg-gray-100 font-medium">
              <td colSpan="3" className="border px-3 py-2 text-right">
                Subtotal (Written Test)
              </td>
              <td className="border px-3 py-2 text-center">1750</td>
            </tr>

            {/* Interview */}
            <tr className="bg-white">
              <td className="border px-3 py-2 font-medium">Personality Test</td>
              <td colSpan="2" className="border px-3 py-2">
                Interview/Personality Test
              </td>
              <td className="border px-3 py-2 text-center">275</td>
            </tr>

            {/* Grand Total */}
            <tr className="bg-gray-200 font-bold">
              <td colSpan="3" className="border px-3 py-2 text-right">
                Grand Total
              </td>
              <td className="border px-3 py-2 text-center">2025</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Note */}
      <p className="mt-4 text-sm text-gray-700">
        <strong>*</strong> Papers marked with an asterisk are optional subjects.
        Candidates must choose one optional subject comprising Paper VI and
        Paper VII. These optional papers are counted towards total marks only if
        attempted. Option numbers (i), (ii) indicate the sequence of the
        optional papers.
      </p>
    </div>
  );
}
